import { Injectable ,inject} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  cookieService = inject(CookieService);

  constructor(private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('user');
      // const cookieExists: boolean = this.cookieService.check('vicas_token');
 
      if (token) {
        // User is authenticated, allow access to the route
   
        return true;
      }
      // If not authenticated, redirect to the login page
      // Store the attempted URL for redirect after login as a query param
      this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url } });
      return false;
  }
}
